import {RestResource} from '../rest'
import {DCIM_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const tree = new RestResource({server: DCIM_SERVER, resource: 'general-tree'});

tree.pathCode = (pathCode) => {
    let url = `${DCIM_SERVER}/general-tree/path-code?pathCode=${pathCode}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

tree.findByCategoryIdAndReferenceId = (categoryId, referenceId) => {
    let url = `${DCIM_SERVER}/general-tree/category/${categoryId}/reference/${referenceId}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

//查询节点及其后代节点
tree.findNodeAndDescendantsByPathCode = (pathCode) => {
    let url = `${DCIM_SERVER}/general-tree/path-code/node-descendants?pathCode=${pathCode}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

//查询节点及其后代节点(指定业务idList)
tree.findNodeAndDescendantsByPathCodeAndReferenceList = (pathCode, referenceList) => {
    let url = `${DCIM_SERVER}/general-tree/pathCodeAndReferenceList/node-descendants/pathCode/${pathCode}`;
    return new Promise((resolve, reject) => {
        athubAxios.postByJson(url, {'referenceList': referenceList}).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * 把树形结构平铺
 * @param treeData  后台返回的原始树形结构数据
 * @param flatTreeData  平铺后的数据
 */
tree.flatTreeOper = (treeData, flatTreeData) => {
    for (let i = 0; i < treeData.length; i++) {
        let row = treeData[i];
        flatTreeData.push(row);
        if (row.children.length > 0) {
            tree.flatTreeOper(row.children, flatTreeData);
        }
    }
}

/**
 * 根据选定树的根节点以及平铺的树信息，构建一颗树
 * @param parentId  根节点
 * @param filterFlatTreeData  平铺的满足条件的树记录
 */
tree.buildTreeOper = (parentId, filterFlatTreeData) => {
    let treeInfoArr = new Array();
    for (let i = 0; i < filterFlatTreeData.length; i++) {
        let pid = filterFlatTreeData[i].parentId;
        if (pid == parentId) {
            let ppid = filterFlatTreeData[i].id;
            filterFlatTreeData[i].children = tree.buildTreeOper(ppid, filterFlatTreeData);
            treeInfoArr.push(filterFlatTreeData[i]);
        }
    }
    return treeInfoArr;
}

/**
 * 根据业务条件筛选的结果以及平铺的树记录，获取需要展开的树的节点id列表
 * @param flatTreeData  平铺后的数据
 * @param treeIdReferenceMap    树的id->reference映射
 * @param referenceId   每个满足筛选条件的业务主键
 * @param allReferenceIds   满足筛选条件的父/祖先的业务主键
 */
tree.getAllReferenceIdsBylReferenceId = (flatTreeData, treeIdReferenceMap, referenceId, allReferenceIds) => {
    for (let j = 0; j < flatTreeData.length; j++) {
        if (referenceId == flatTreeData[j].referenceId) {
            allReferenceIds.push(referenceId);
            let parentId = flatTreeData[j].parentId;
            tree.getAllReferenceIdsBylReferenceId(flatTreeData, treeIdReferenceMap, treeIdReferenceMap.get(parentId), allReferenceIds);
        }
    }
}

export default tree;
